
export class SaData {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            if (json.results) this.results = json.results.map(r => new SaResult(r));
        }
    }

    count: number;
    next: string;
    previous: string;
    results: SaResult[];
}

export class SaResult {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            if (json.sprinkler) this.sprinkler = new SaSprinkler(json.sprinkler);
            if (json.recorded_date) this.recordedDate = new Date(json.recorded_date);
        }
    }

    pk: number;
    sprinkler: SaSprinkler;
    moisture_mean: number;
    moisture_uniformity: number;
    number_of_measurements: number;
    high_moisture_alert = false;
    low_moisture_alert = false;
    uniformity_alert = false;
    // recorded_date: Date;
    recorded_date: string;
    recordedDate: Date;
}


export class SaSprinkler {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            if (json.central_coordinates) this.central_coordinates = new SaCoordinateInfo(json.central_coordinates);
        }
    }

    pk: number;
    radius_thresh: number;
    organization_id: number;
    geometry_type: string;
    hole_id: number;
    // sprinkler_name: string;
    name: string;
    // radius_thres: number;
    // longitude: number;
    // latitude: number;
    central_coordinates: SaCoordinateInfo
}

export class SaCoordinateInfo {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            if (json.coordinates != null && json.coordinates.length == 2) {
                this.latitude = json.coordinates[1];
                this.longitude = json.coordinates[0];
            }
            delete this['coordinates'];
        }
    }

    type: string;
    latitude: number;
    longitude: number;
}

export class SaUpdateTargetVwcResponse {
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
        }
    }

    suggestedAdjustAmtIn: number;
    suggestedAdjustAmtPercent: number;
}
